import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';

/**
 * Handles the `redirectUri`.
 *
 * All the authentication work is already done by the `AuthProvider`. Here we
 * wait until we have the user and then redirect to the home screen.
 */
export const Callback = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    /* istanbul ignore else -- @preserve */
    if (user) {
      navigate('/', { replace: true });
    }
  }, [user]);

  return <></>;
};
